<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        <img
          src="media/icons/duotune/abstract/abs039.svg"
          class="me-2"
        />Financeiro - Licenças
      </h3>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisar"
              type="text"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar"
              v-model="this.pesquisa"
              @input="onSearch()"
            />
          </div>
        </div>
        <div class="card-toolbar"></div>
      </div>
      <div class="card-body pt-0">
        <div v-if="!loadingLicencas">
          <div class="table-responsive" id="no-more-tables">
            <table
              class="table dataTable table-rounded border gy-3 gs-4 table align-middle table-row-dashed fs-6 dataTable no-footer"
            >
              <thead class="bg-light">
                <tr
                  class="fw-semibold fs-6 text-gray-800 border-bottom border-gray-200"
                >
                  <th tabindex="0" rowspan="1" colspan="1"></th>
                  <th></th>
                  <th class="fw-bold">ID</th>
                  <th class="fw-bold">Nome da Revenda</th>
                  <th>Cidade/UF</th>
                  <th class="fw-bold">Clientes</th>
                  <th class="fw-bold">Total Contrato</th>
                </tr>
              </thead>
              <tbody class="fw-bold text-gray-800 h-auto">
                <template
                  v-for="(licenca, index) in this.licencas"
                  :key="index"
                >
                  <tr>
                    <td style="font-size: 14px">
                      <a @click="toggleRow(index)">
                        <span
                          v-if="openRows[index]"
                          class="svg-icon svg-icon-primary"
                        >
                          <inline-svg
                            src="media/icons/duotune/general/gen036.svg"
                          />
                        </span>
                        <span v-if="!openRows[index]" class="svg-icon">
                          <inline-svg
                            src="media/icons/duotune/general/gen035.svg"
                          />
                        </span>
                      </a>
                    </td>
                    <td>
                      <div
                        v-if="
                          licenca.logo && licenca.logo !== null
                            ? licenca.logo
                            : ''
                        "
                        class="symbol symbol-40px"
                      >
                        <div
                          class="symbol-label fs-2 fw-bold bg-light-dark"
                          :style="{
                            'background-image': `url(${
                              this.$utils.getUrl() + licenca.logo
                            })`,
                          }"
                        ></div>
                      </div>
                      <div v-else class="symbol symbol-40px">
                        <div
                          :class="[
                            'symbol-label fs-2 fw-bold ' + licenca.color,
                          ]"
                        >
                          {{
                            licenca.nome && licenca.nome !== null
                              ? licenca.nome.substring(0, 1).toUpperCase()
                              : ""
                          }}
                        </div>
                      </div>
                    </td>
                    <td>{{ licenca.id }}</td>
                    <td data-title="Nome Revenda">
                      {{ licenca.nome }}
                      <span class="text-muted fw-bold d-block fs-8">
                        {{
                          licenca.fantasia +
                          " - " +
                          this.$utils.setMask(
                            licenca.cnpj,
                            "##.###.###/####-##",
                            true
                          )
                        }}
                      </span>
                    </td>
                    <td data-title="Cidade/UF">
                      {{ licenca.cidade + "/" + licenca.uf }}
                    </td>
                    <td data-title="Qtd Clientes">
                      <span
                        class="badge badge-square text-gray-800 badge-light d-flex p-2"
                        >{{ licenca.Emitentes.length }}</span
                      >
                    </td>
                    <td data-title="Total Contrato">
                      <span
                        class="badge badge-square badge-light text-gray-800 py-3 d-flex p-2"
                        >{{
                          "R$ " +
                          this.$utils.formatarNumero(licenca.totalContrato)
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr
                    v-if="
                      licenca.Emitentes &&
                      licenca.Emitentes.length > 0 &&
                      openRows[index]
                    "
                  >
                    <td colspan="7">
                      <div class="table-responsive my-5">
                        <table
                          class="table dataTable table-rounded border gy-3 gs-4 table align-middle table-row-dashed fs-6 dataTable no-footer"
                        >
                          <thead class="bg-light">
                            <tr
                              class="fw-semibold fs-6 text-gray-800 border-bottom border-gray-200"
                            >
                              <th>ID</th>
                              <th>Nome</th>
                              <th>Cidade/UF</th>
                              <th>Pacote</th>
                              <th>Qtd Terminais</th>
                              <th>Qtd PDV</th>
                              <th>Valor Licença</th>
                              <th>Data Cadastro</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody class="fw-bold text-gray-800 h-auto">
                            <tr
                              v-for="emitente in licenca.Emitentes"
                              :key="emitente"
                            >
                              <td data-title="ID">{{ emitente.id }}</td>
                              <td data-title="Nome Cliente">
                                {{ emitente.nome }}
                                <span class="text-muted fw-bold d-block fs-8">
                                  {{
                                    emitente.fantasia +
                                    " - " +
                                    this.$utils.setMask(
                                      emitente.cnpj,
                                      "##.###.###/####-##",
                                      true
                                    )
                                  }}
                                </span>
                              </td>
                              <td data-title="Cidade/UF">
                                {{ emitente.cidade + "/" + emitente.uf }}
                              </td>
                              <td data-title="Tipo Pacote">
                                <span
                                  class="badge badge-square text-gray-800 badge-light-info d-flex p-2"
                                  >{{
                                    this.retornarTipoPacote(
                                      emitente.tipo_pacote
                                    )
                                  }}</span
                                >
                              </td>
                              <td data-title="Qtd Terminais">
                                <span class="d-flex justify-content-center">
                                  {{ emitente.qtd_terminais }}
                                </span>
                              </td>
                              <td data-title="Qtd PDV">
                                <span class="d-flex justify-content-center">
                                  {{ emitente.qtd_pdv }}
                                </span>
                              </td>
                              <td data-title="Valor Contrato">
                                {{
                                  "R$ " +
                                  this.$utils.formatarNumero(
                                    emitente.valor_contrato
                                  )
                                }}
                              </td>
                              <td data-title="Data de Cadastro">
                                {{
                                  this.$utils.formatarDataHora(
                                    emitente.createdAt
                                  )
                                }}
                              </td>
                              <td>
                                <button
                                  class="btn btn-sm btn-light"
                                  @click="visualizarEmitente(emitente)"
                                >
                                  <span class="svg-icon svg-icon-2">
                                    <inline-svg
                                      src="/media/icons/duotune/general/gen004.svg"
                                    />
                                  </span>
                                  Visualizar
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="mt-2">
                        <div class="d-flex justify-content-end mt-2">
                          <div
                            class="border border-secondary bg-light-secondary rounded min-w-125px py-3 px-6 mb-3 me-3"
                          >
                            <div class="d-flex align-items-center">
                              <span
                                class="svg-icon svg-icon-5 svg-icon-success me-2"
                              >
                                <inline-svg
                                  src="media/icons/duotune/arrows/arr066.svg"
                                />
                              </span>
                              <div class="fs-2 fw-bold text-gray-800">
                                {{ licenca.Emitentes.length }}
                              </div>
                            </div>
                            <div class="fw-semibold fs-6 text-gray-600">
                              Qtd Clientes
                            </div>
                          </div>
                          <div
                            class="border border-secondary bg-light-secondary rounded min-w-125px py-3 px-6 mb-3"
                          >
                            <div class="d-flex align-items-center">
                              <span
                                class="svg-icon svg-icon-5 svg-icon-success me-2"
                              >
                                <inline-svg
                                  src="media/icons/duotune/arrows/arr066.svg"
                                />
                              </span>
                              <div class="fs-2 fw-bold text-gray-800">
                                {{
                                  "R$ " +
                                  this.$utils.formatarNumero(
                                    licenca.totalContrato
                                  )
                                }}
                              </div>
                            </div>
                            <div class="fw-semibold fs-6 text-gray-600">
                              Total Contratos
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="pt-2">
            <div class="d-flex justify-content-end mt-2">
              <div
                class="border border-warning bg-light-warning rounded min-w-125px py-3 px-6 me-3 mb-3"
              >
                <div class="d-flex align-items-center">
                  <span class="svg-icon svg-icon-5 svg-icon-success me-2">
                    <inline-svg src="media/icons/duotune/arrows/arr066.svg" />
                  </span>
                  <div class="fs-2 fw-bold">
                    {{ totalEmitentesGeral }}
                  </div>
                </div>
                <div class="fw-semibold fs-6 text-gray-600">
                  Qtd Total Clientes
                </div>
              </div>
              <div
                class="border border-success bg-light-success rounded min-w-125px py-3 px-6 mb-3"
              >
                <div class="d-flex align-items-center">
                  <span class="svg-icon svg-icon-5 svg-icon-success me-2">
                    <inline-svg src="media/icons/duotune/arrows/arr066.svg" />
                  </span>
                  <div class="fs-2 fw-bold">
                    {{
                      "R$ " +
                      this.$utils.formatarNumero(this.totalContratoGeral)
                    }}
                  </div>
                </div>
                <div class="fw-semibold fs-6 text-gray-600">
                  Total Contratos
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="loadingLicencas"
          v-bind:data-kt-indicator="loadingLicencas ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            Aguarde, carregando...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {},
  props: {},
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async carregarLicencas() {
      this.loadingLicencas = true;

      try {
        let consulta = "?$select=id,nome,fantasia,cidade,uf,cnpj,logo";
        consulta +=
          "&$expand=Emitentes($select=id,nome,fantasia,cnpj,cidade,uf,tipo_pacote,qtd_terminais,qtd_pdv,valor_contrato,logo,createdAt;$orderby=createdAt desc)";
        consulta += "&$filter=ativo eq '1'";

        if (
          this.pesquisa &&
          this.pesquisa !== null &&
          this.pesquisa.length > 0
        ) {
          consulta +=
            "and (contains(nome, '" +
            this.pesquisa +
            "') or contains(cnpj, '" +
            this.$utils.unMask(this.pesquisa) +
            "') or contains(fantasia, '" +
            this.pesquisa +
            "'))";
        }
        consulta += "&$orderby=nome";

        let retLicencas = await this.$store.dispatch(
          "revenda/getRevendaOData",
          consulta
        );

        if (retLicencas && retLicencas !== null) {
          this.licencas = retLicencas.value.map((licenca) => {
            licenca.totalContrato = licenca.Emitentes.reduce(
              (total, emitente) => total + emitente.valor_contrato,
              0
            );
            licenca.totalEmitentes = licenca.Emitentes.length;
            licenca.color = this.$utils.getColorRandom();
            return licenca;
          });
          this.totalContratoGeral = this.licencas.reduce(
            (total, licenca) => total + licenca.totalContrato,
            0
          );
          this.totalEmitentesGeral = this.licencas.reduce(
            (total, licenca) => total + licenca.totalEmitentes,
            0
          );
        }
      } catch (error) {
        console.log(error);
      }

      this.loadingLicencas = false;
    },
    retornarTipoPacote(pacote) {
      const pacoteMap = {
        0: "Emissor Gratuíto",
        1: "Emissor",
        2: "Gestor",
        3: "Indústria",
      };

      return pacoteMap[pacote] || "Pacote não definido";
    },
    toggleRow(index) {
      this.openRows[index] = !this.openRows[index];
    },
    visualizarEmitente(emitente) {
      this.$router.push("/principal/empresas/editar/" + emitente.id);
    },
    async onSearch() {
      setTimeout(async () => {
        await this.carregarLicencas();
      }, 600);
    },
  },
  async mounted() {
    await this.carregarLicencas();
  },
  data() {
    return {
      loadingLicencas: false,
      licencas: [],
      openRows: [],
      totalContratoGeral: 0,
      totalEmitentesGeral: 0,
      pesquisa: "",
    };
  },
};
</script>

<style lang="scss">
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
  border-spacing: 0;
}

table.dataTable > thead {
  th.sorting {
    position: relative;
  }
  .sorting:after {
    position: absolute;
  }
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none;
  border-radius: 0.475rem;
  font-weight: 500;
  font-size: 1.075rem;
  font-family: Poppins, Helvetica, sans-serif;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #009ef7;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
}

table.dataTable {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

th,
thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

@media only screen and (max-width: 768px) {
  #no-more-tables table,
  #no-more-tables thead,
  #no-more-tables tbody,
  #no-more-tables th,
  #no-more-tables td,
  #no-more-tables tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  #no-more-tables tbody {
    border: 0px solid rgb(235, 235, 235);
  }

  #no-more-tables table {
    border: 0px solid rgb(235, 235, 235);
  }

  #no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  #no-more-tables tr {
    margin-bottom: 18px;
  }

  #no-more-tables tr:nth-child(even) {
    border-left: 0px solid rgb(133, 189, 226);
  }

  #no-more-tables tr:nth-child(odd) {
    border-left: 0px solid rgb(152, 126, 212);
  }

  #no-more-tables td {
    //display: flex;
    width: 100%;
    border-bottom: 0px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  #no-more-tables td:before {
    content: attr(data-title);
    display: block;
    color: #999;
    top: 6px;
    left: 5px;
    min-width: 25%;
    padding-right: 0.8em;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    font-size: 1.2vh;
  }
}
</style>
